<template>
    <div style="background-color: #f8f8f8;" id="not-found">
        <cms-side-bar v-if="computedLoggedIn"></cms-side-bar>
        <div style="background-color: #f8f8f8;" class="content-wrapper">
            <div class="page-heading">
                <div class="page-content fade-in-up">
                    <div style="margin-top: 3%" class="row">
                        <div class="col-md-12 text-center">
                            <div><img src="/assets/404.png" alt="404"></div>
                            <div style="color: grey;" class="mt-3 font-bold">{{$t('message.pageNotFound')}}.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import CmsSideBar from './cms/CmsSidebar';

  export default {
    name: 'NotFound',
    components: {
      CmsSideBar
    }
  }
</script>

<style scoped>

</style>